"use client";
import { Box, Image, Text, Link, useBreakpointValue } from "@chakra-ui/react"
import React, { useRef, useEffect, useState } from "react"
import { handleKarmaNavigation, modifyDatoImgUrlToStatic } from "./utils";
import Slider from 'react-slick';
import { nanoid } from 'nanoid';


let svgIcons = {
    'video': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 4.74976H15.25V19.2498H2.75V4.74976Z" stroke="#B7870C" stroke-width="1.5" />
        <path d="M15.25 9.99976L21.25 6.99976V16.9998L15.25 13.9998V9.99976Z" stroke="#B7870C" stroke-width="1.5" />
    </svg>,
    'poem': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 3.75V3H2V3.75H2.75ZM16.25 3.75H17V3H16.25V3.75ZM21.25 12H22V11.25H21.25V12ZM6.75 15H6V16.5H6.75V15ZM12.25 16.5H13V15H12.25V16.5ZM6.75 7.75V7H6V7.75H6.75ZM12.25 7.75H13V7H12.25V7.75ZM12.25 12.25V13H13V12.25H12.25ZM6.75 12.25H6V13H6.75V12.25ZM2.75 3.75V4.5H16.25V3.75V3H2.75V3.75ZM21.25 17.75H22V12H21.25H20.5V17.75H21.25ZM16.25 3.75H15.5V12H16.25H17V3.75H16.25ZM16.25 12H15.5V17.75H16.25H17V12H16.25ZM21.25 12V11.25H16.25V12V12.75H21.25V12ZM2.75 3.75H2V17.75H2.75H3.5V3.75H2.75ZM5.25 20.25V21H18.5V20.25V19.5H5.25V20.25ZM2.75 17.75H2C2 19.5449 3.45507 21 5.25 21V20.25V19.5C4.2835 19.5 3.5 18.7165 3.5 17.75H2.75ZM18.75 20.25V21C20.5449 21 22 19.5449 22 17.75H21.25H20.5C20.5 18.7165 19.7165 19.5 18.75 19.5V20.25ZM18.75 20.25V19.5C17.7835 19.5 17 18.7165 17 17.75H16.25H15.5C15.5 19.5449 16.9551 21 18.75 21V20.25ZM6.75 15.75V16.5H12.25V15.75V15H6.75V15.75ZM6.75 7.75V8.5H12.25V7.75V7H6.75V7.75ZM12.25 7.75H11.5V12.25H12.25H13V7.75H12.25ZM12.25 12.25V11.5H6.75V12.25V13H12.25V12.25ZM6.75 12.25H7.5V7.75H6.75H6V12.25H6.75Z" fill="#B7870C" />
    </svg>,
    'text': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 3.75V3H2V3.75H2.75ZM16.25 3.75H17V3H16.25V3.75ZM21.25 12H22V11.25H21.25V12ZM6.75 15H6V16.5H6.75V15ZM12.25 16.5H13V15H12.25V16.5ZM6.75 7.75V7H6V7.75H6.75ZM12.25 7.75H13V7H12.25V7.75ZM12.25 12.25V13H13V12.25H12.25ZM6.75 12.25H6V13H6.75V12.25ZM2.75 3.75V4.5H16.25V3.75V3H2.75V3.75ZM21.25 17.75H22V12H21.25H20.5V17.75H21.25ZM16.25 3.75H15.5V12H16.25H17V3.75H16.25ZM16.25 12H15.5V17.75H16.25H17V12H16.25ZM21.25 12V11.25H16.25V12V12.75H21.25V12ZM2.75 3.75H2V17.75H2.75H3.5V3.75H2.75ZM5.25 20.25V21H18.5V20.25V19.5H5.25V20.25ZM2.75 17.75H2C2 19.5449 3.45507 21 5.25 21V20.25V19.5C4.2835 19.5 3.5 18.7165 3.5 17.75H2.75ZM18.75 20.25V21C20.5449 21 22 19.5449 22 17.75H21.25H20.5C20.5 18.7165 19.7165 19.5 18.75 19.5V20.25ZM18.75 20.25V19.5C17.7835 19.5 17 18.7165 17 17.75H16.25H15.5C15.5 19.5449 16.9551 21 18.75 21V20.25ZM6.75 15.75V16.5H12.25V15.75V15H6.75V15.75ZM6.75 7.75V8.5H12.25V7.75V7H6.75V7.75ZM12.25 7.75H11.5V12.25H12.25H13V7.75H12.25ZM12.25 12.25V11.5H6.75V12.25V13H12.25V12.25ZM6.75 12.25H7.5V7.75H6.75H6V12.25H6.75Z" fill="#B7870C" />
    </svg>,
    'audio': <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0009 19C15.0764 19 17.7195 17.1489 18.8769 14.5M12.0009 19C8.92546 19 6.28233 17.1489 5.125 14.5M12.0009 19V21.25M12.0009 15.75C9.65372 15.75 7.75093 13.8472 7.75093 11.5V7C7.75093 4.65279 9.65372 2.75 12.0009 2.75C14.3481 2.75 16.2509 4.65279 16.2509 7V11.5C16.2509 13.8472 14.3481 15.75 12.0009 15.75Z" stroke="#B7870C" stroke-width="1.5" stroke-linecap="square" />
    </svg>
}

let RelatedPosts = ({ sectionContent }) => {

    // for testing slider
    // sectionContent.relatedPosts[3] = sectionContent.relatedPosts[0]
    // sectionContent.relatedPosts[4] = sectionContent.relatedPosts[1]

    const [lineClamps, setLineClamps] = useState({});
    const containerRef = useRef(null);

    let increamentFactor = useBreakpointValue({base: 1, lg: 2, xl: 3})

    
    let [unqSliderId, setUnqSliderId] = useState(new Date().getTime())
    let [sliderKey, setSliderkey] = useState(0)
    const [currentSlide, setCurrentSlide] = useState(0);
    let [isEndReached, setIsEndReached] = useState(false)

    let [windowInnerWidth, setWindowInnerWidth] = useState(0)

    useEffect(() => {
        if(typeof window !== undefined){
            setWindowInnerWidth(window.innerWidth/1-20)
        }
        const handleResize = () => {
            setSliderkey(prev => prev + 1)
        }
        window.addEventListener("resize", handleResize)
        window.removeEventListener("resize", handleResize)
    }, [])


    useEffect(() => {        
        if (currentSlide + increamentFactor === sectionContent?.relatedPosts?.length) {
            setIsEndReached(true)
        }
        else {
            setIsEndReached(false)
        }
    }, [currentSlide])   

    const NextArrow = ({ onClick }) => {
        if (!isEndReached) {
        return (
            <Box
                as="div"
                pos="absolute"
                right={{md: '-2rem', lg: '-4rem'}}
                top={"43%"}
                zIndex="10"
                display={{ base: 'none', xl: sectionContent?.relatedPosts?.length/1 > 3  ? 'block' : 'none' }}
            >
                <Box
                    cursor="pointer"
                    bgColor="#FFFFFF"
                    borderRadius="50%"
                    w={{base:'36px', md:'46px'}}
                    h={{base:'36px', md:'46px'}}
                    bgPos="center"
                    bgRepeat="no-repeat"
                    color="transparent"
                    bgImage={`url(https://static.sadhguru.org/d/46272/1752053543-karmasliderrightarrow.svg)`}
                    bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                    border={'2px solid #B7870C'}
                    onClick={onClick}
                    _hover={{
                        background: '#030040',
                        border: '2.56px solid #B7870C',
                        bgImage: 'url(https://static.sadhguru.org/d/46272/1755495244-karmasliderleftarrowhovericon.svg)',
                        transform: 'rotate(180deg)',
                        bgPos: "center",
                        bgRepeat: "no-repeat"
                    }}
                />
            </Box>)
        }
    };

    const PrevArrow = ({ onClick }) => {
        if (currentSlide/1 !== 0) {
        return (
            <Box
                as="div"
                pos="absolute"
                left={{md: '-4rem', lg: "-6rem"}}
                top={"43%"}
                // transform="translateY(-50%)"
                zIndex="10"
                display={{ base: 'none', xl: sectionContent?.relatedPosts?.length/1 > 3  ? 'block' : 'none'}}
            >
                <Box
                    cursor="pointer"
                    bgColor="#fff"
                    borderRadius="50%"
                    w={{base:'36px', md:'46px'}}
                    h={{base:'36px', md:'46px'}}
                    bgPos="center"
                    bgRepeat="no-repeat"
                    color="transparent"
                    transform={'rotate(180deg)'}
                    bgImage={`url(https://static.sadhguru.org/d/46272/1752053543-karmasliderrightarrow.svg)`}
                    bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                    // boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
                    border={'2px solid #B7870C'}
                    onClick={onClick}
                    _hover={{
                        background: '#030040',
                        border: '2.56px solid #B7870C',
                        bgImage: 'url(https://static.sadhguru.org/d/46272/1755495244-karmasliderleftarrowhovericon.svg)',
                        transform: 'rotate(0deg)',
                        bgPos: "center",
                        bgRepeat: "no-repeat"
                    }}
                />
            </Box>
        );
        }
    };

    let slickSliderWidth = useBreakpointValue({base: typeof window !== undefined ? `${(windowInnerWidth)}px` : '100%', md: '760px', xl: '1040px'})


    const settings = {
        dots: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 2000,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        centerPadding: '0px',
        infinite: false,
        beforeChange: (prev, current) => setCurrentSlide(current),
        responsive: [
            {
                breakpoint: 835,
                settings: { slidesToShow: 2.2, slidesToScroll: 1, initialSlide: 0, centerMode: false, centerPadding: '0px' },
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 0, centerMode: false, centerPadding: '0px' },
            },
            {
                breakpoint: 450,
                settings: { slidesToShow: 1.04, slidesToScroll: 1, initialSlide: 0, centerMode: false, centerPadding: '0px' },
            },
        ],

        appendDots: dots => (
            <div
                style={{
                    marginTop: '2rem',
                    position: 'static',
                }}
            >
                <ul style={{ margin: '0px' }}> {dots} </ul>
            </div>
        ),
        customPaging: function (i) {
            return (
                <Text
                    className="custom-dot"
                    cursor="pointer"
                    display="inline-block"
                    w={{ base: '15px', md: "12px", lg: '15px' }}
                    h={{ base: '15px', md: "12px", lg: '15px' }}
                    bgColor={parseInt(currentSlide) / 1 == i / 1 ? '#fff' : 'transparent'}
                    borderRadius="50%"
                    border={'1px solid #fff'}
                    transition="all 0.3s ease"
                ></Text>
            );
        },
    };

    const calculateAvailableLines = (titleElement, containerHeight = 244) => {
        if (!titleElement) return 3; // fallback

        const titleHeight = titleElement.offsetHeight;
        const padding = 95; // 20px top + 20px bottom + 20px icon space
        const availableHeight = containerHeight - titleHeight - padding;
        const lineHeight = 21; // summary line height
        const maxLines = Math.floor(availableHeight / lineHeight);

        return Math.max(1, maxLines); // minimum 1 line
    };

    useEffect(() => {
        if (containerRef.current && sectionContent?.relatedPosts) {
            const containers = containerRef.current.querySelectorAll('.blog-container');
            const newLineClamps = {};

            containers.forEach((container, index) => {
                const titleEl = container.querySelector('.blog-title');
                const lineClamp = calculateAvailableLines(titleEl);
                newLineClamps[index] = lineClamp;
            });

            setLineClamps(newLineClamps);
        }
    }, [sectionContent]);


    return (<Box py={{ base: '70px', md: '100px' }} display={'flex'} justifyContent={'center'} bgColor={'#EFE7D6'}>

        <Box pl={{base: '10px', md: '0px'}} ref={containerRef} display={'flex'} flexDir={{ base: 'column', md: 'column' }} 
        justifyContent={'center'} gap={'30px'}
        >

            <Text
                display={'inline'}
                width={'100%'}
                textAlign={'left'}
                color={'#B7870C'}
                fontFamily={'var(--AustinMedium)'}
                fontSize={{ base: '34px', md: '60px' }}
                lineHeight={{ base: '36px', md: '60px' }}
            >{'Related Posts'}</Text>

            <Box
                cursor={'grab'}
                id={`karmaRelatedPostsid${unqSliderId}`}
                maxW={'100%'}
                w='100%'
            >
            <Slider key={sliderKey} {...settings} m="0"
                beforeChange={(current, next) => setCurrentSlide(next)}  >
                {sectionContent?.relatedPosts?.map((item, j) => {
                    return <Link
                        key={nanoid()}
                        textDecoration={'none'}
                        href={handleKarmaNavigation(`${`/articles/${item?.urlAlias}`}`)}
                        _hover={{
                            textDecor: 'none'
                        }}
                    >
                        <Box 
                            width={'319px'}
                            >
                            <Image width={'100%'} height={'180px'}
                                src={modifyDatoImgUrlToStatic(item?.heroImage?.url)}
                            />
                            <Box className="blog-container" padding={'20px'} pt={'15px'} height={'244px'} border={'1px solid #B7870C'} display={'flex'} flexDirection={'column'}
                                bgColor={'#fff'} >
                                {svgIcons[item?.articleType]}
                                <Text
                                    className="blog-title"
                                    my={'20px'} fontWeight={500} color={"#000000"} fontFamily={'var(--AustinMedium)'} fontSize={{ base: '26px' }} lineHeight={{ base: '24px' }}>{item?.title}</Text>
                                <Box flex={1} minHeight={0} overflow={'hidden'}>
                                    <Text
                                        fontWeight={400} color={"#000000"} fontFamily={'var(--FedraSansStd-book)'} fontSize={{ base: '14px' }} lineHeight={{ base: '21px' }}
                                        style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: lineClamps[j] || 3,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    >
                                        {item?.summary}
                                    </Text>
                                </Box>
                            </Box>
                        </Box>
                    </Link>
                })}
            </Slider>
            </Box>
        </Box>
        <style>
            {`#karmaRelatedPostsid${unqSliderId} .slick-slider {
                width: ${slickSliderWidth};    
            }`}
        </style>
    </Box>)
}

export default RelatedPosts;